export default {
    page_title: "Análisis RFM",
    legend_frequency_monetary: "Promedio entre frecuencia y valor monetario",
    recency: "Recencia",
    last_purchase: "Última compra",
    range_to: "a",
    purchases: "compras",
    made_in_last: "Realizadas en los últimos",
    spent_in_last: "Gastado en los últimos",
    days: "días",
    client: "Cliente",
    phone: "Teléfono",
    email: "Email",
    frequency: "Frecuencia",
    monetary: "Monetario",
    score: "Puntuación RFM",
};
